export default __webpack_public_path__ + "static/media/Q1_1_resized.1e08e8fc.jpg";